export default function objectFlip(object) {
    return Object.keys(object)
        .reduce((acc, key) => {
            acc[object[key]] = key

            return acc
        }, {})
}